import Guard from '@/services/middleware'

const ChatInternalLayout = () => import('@/layouts/ChatInternal.vue')

export default [
    {
        path: '/chat-interno',
        component: ChatInternalLayout,
        beforeEnter: [ Guard.redirectIfNotAuthenticated, Guard.checkModuleAccess ],
        meta: { title: 'Chat interno' },
    },
]
